<template>
    <div class="dataTables_wrapper" :style="wrapperStyle">
        <!-- Entries input and search -->
        <mdb-row>
            <mdb-col sm="6" md="7">
                <mdb-row>
                    <mdb-col sm="12" md="12">
                        <datatable-select :title="entriesTitle" v-if="pagination" @getValue="updateEntries" :options="options" :selectvalue="entries"/>
                    </mdb-col>
                    <mdb-col v-if="refresh" class="">
                        <mdb-btn @click="updateData($event)" size="sm" class="d-flex justify-content-center align-items-center" outline="primary">
                            <mdb-icon icon="sync"/>
                        </mdb-btn>
                    </mdb-col>
                </mdb-row>
            </mdb-col>
            <mdb-col sm="6" md="5" v-if="searching" style="display:inline-flex;justify-content: flex-end;">
                <datatable-search class="" :placeholder="searchPlaceholder" @getValue="updateSearch"/>
            </mdb-col>
        </mdb-row>
        <!-- Entries input and search -->

        <!-- Main table -->
        <tbl v-if="!scrollY" v-bind="tableProps" sm datatable class="div-overflow" style="overflow: auto;">
            <tbl-head v-if="showHeaderState" :color="headerColor" :textWhite="headerWhite">
                <tr v-if="showHeaderUpperState" class="header-upper">
                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :class="checkboxClass" :style="checkboxColumnStyle"></th>
                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle"></th>
                    <th v-for="columnUpper in columnUppers" :class="columnUpper.headerClass" :style="columnUpper.headerStyle" :colspan="columnUpper.colSpan">
                        <div v-html="columnUpper.label"></div>
                    </th>
                    <th v-if="showEditColumnState" class="" :style="editColumnStyle"></th>
                    <th v-if="showSortColumn" class="" :style="editColumnStyle"></th>
                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                </tr>
                <tr>
                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                        <div v-if="multiSelectable && showSelectCheckbox && showSelectAllState" class="form-check" style="width: 100%;height: 100%;padding-left: 0;display: flex;align-items: center;justify-content: center;">
                            <input type="checkbox" class="form-check-input" :id="comp_uuid + '_select_all'" name="row_select_all" v-model="selectAll">
                            <label class="form-check-label" :for="comp_uuid + '_select_all'" :style="checkboxCellStyle"></label>
                        </div>
                        <div v-if="selectable && showSelectCheckbox"></div>
                    </th>
                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle">編集</th>
                    <th v-for="column in columns" :key="column.field" :class="column.headerClass" :style="column.headerStyle" v-on:click="sort(column.field, column.sort)">
                        <div v-if="!column.canEditHeader">{{ column.label }}</div>
                        <div v-if="column.canEditHeader"><input type="text" :class="column.headerEditorClass" :value="column.label" :name="column.headerEditorName" @change="changeHeader"/></div>
                    </th>
                    <th v-if="showEditColumnState" class="" :style="editColumnStyle">編集</th>
                    <th v-if="showSortColumn" class="" :style="editColumnStyle">並び替え</th>
                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                </tr>
            </tbl-head>
            <tbl-body>
<!--                <tr v-for="(row,index) in pages[activePage]" :key="row.key" :data-key="row.key" :data-index="index" @dblclick.stop="onRowDblClick($event,row.key)" @click.stop="onRowSelected($event,row.key)" :class="[{'row-selected': row.selected }]">-->
                <tr v-for="(row,index) in pages[activePage]" :key="row.key" :data-key="row.key" :data-index="index" @dblclick.stop="onRowDblClick($event,row.key)" :class="[{'row-selected': row.selected }]">
                    <td v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                        <div class="form-check" style="padding-left: 0;display: flex;align-items: center;justify-content: center;">
                            <input type="checkbox" class="form-check-input" :id="comp_uuid + '_row_checkbox_' + index" name="row_selected" :checked="rowSelection.indexOf(row.key)>=0" v-bind:value="row.key" v-on:change.stop="onCheckRow($event,row.key)" :disabled="readonlyRow.indexOf(row.key)>=0">
                            <label class="form-check-label" :for="comp_uuid + '_row_checkbox_' + index" :style="checkboxCellStyle"></label>
                        </div>
                    </td>
                    <td v-if="showTopEditColumn" class="editor-column" :style="editColumnStyle" @click.stop="onRowSelected($event,row.key)">
                        <ul class="editor-btns">
                            <li v-if="displayDownloadButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onDownloadButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 105px;color: #FFFFFF;">
                                            <gd-download-item-icon class="icon-btn-15"></gd-download-item-icon>
                                            <span>{{ displayDownloadText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayAddButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onAddButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-add-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                            <gd-add-item-icon class="icon-btn-15"></gd-add-item-icon>
                                            <span>{{ displayAddText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayEditButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onEditButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                            <gd-edit-item-icon class="icon-btn-15"></gd-edit-item-icon>
                                            <span>{{ displayEditText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayRemoveButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onRemoveButtonClick($event,row.key)" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #C01537;min-width: 55px;color: #FFFFFF;">
                                            <gd-remove-item-icon class="icon-btn-15"></gd-remove-item-icon>
                                            <span>{{ displayRemoveText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayLinkButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onLinkButtonClick" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #003C8F;min-width: 65px;color: #FFFFFF;">
                                            <gd-external-link-icon class="icon-btn-15"></gd-external-link-icon>
                                            <span>{{ displayLinkText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayProcessButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onProcessButtonClick" v-bind:class="{disabled:row.isProcessBtn}" class="btn old-btn btn-sm center-icon-btn role-remove-btn" style="background-color: #003C8F;min-width: 65px;color: #FFFFFF;">
                                            <gd-external-link-icon class="icon-btn-15"></gd-external-link-icon>
                                            <span>{{ displayProcessText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </td>
                    <td v-if="editable" v-for="(value, key) in row.data" :key="key" :class="row.class[key]" :style="row.style[key]" @click.stop="onRowSelected($event,row.key)">
<!--                        <input v-if="row.editorType[key] === 'string'" type="text" class="form-control" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]"/>-->
<!--                        <input v-else-if="row.editorType[key] === 'number'" type="number" class="form-control" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]"/>-->
                        <input v-if="row.editorType[key] === 'string'" type="text" :class="row.editorClass[key]" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]" :disabled="readonlyRow.indexOf(row.key)>=0"/>
                        <input v-else-if="row.editorType[key] === 'number'" type="number" :class="row.editorClass[key]" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]" :disabled="readonlyRow.indexOf(row.key)>=0"/>
                        <input v-else-if="row.editorType[key] === 'time'" type="time" :class="row.editorClass[key]" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]" :disabled="readonlyRow.indexOf(row.key)>=0"/>
                        <select v-else-if="row.editorType[key] === 'select'" v-model="row.data[key]" :class="row.editorClass[key]" :name="row.editorName[key]" @change="changeSelectedIndex($event)" :disabled="readonlyRow.indexOf(row.key)>=0">
                            <option v-for="list in row.listData[key]" :value="list.key">{{list.value}}</option>
                        </select>
                        <md-datepicker v-else-if="row.editorType[key] === 'date'" :attr-name="row.editorName[key]" :ref="row.editorName[key]" :value="value" @on-value-change="onValueChangeDatePicker($event, index)" :attr-disabled="readonlyRow.indexOf(row.key)>=0"/>
                        <textarea v-else-if="row.editorType[key] === 'textarea'" :class="row.editorClass[key]" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]" :disabled="readonlyRow.indexOf(row.key)>=0"/>
                        <div v-else v-html="value"></div>
                    </td>
                    <td v-if="!editable" v-for="(value, key) in row.data" :key="key" :class="row.class[key]" :style="row.style[key]" @click.stop="onRowSelected($event,row.key)">
                        <div v-html="value"></div>
                    </td>
                    <td v-if="showEditColumnState" class="editor-column" :style="editColumnStyle" @click.stop="onRowSelected($event,row.key)">
                        <ul class="editor-btns">
                            <li v-if="displayDownloadButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onDownloadButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 105px;color: #FFFFFF;">
                                            <gd-download-item-icon class="icon-btn-15"></gd-download-item-icon>
                                            <span>{{ displayDownloadText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayAddButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onAddButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-add-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                            <gd-add-item-icon class="icon-btn-15"></gd-add-item-icon>
                                            <span>{{ displayAddText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayEditButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onEditButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                            <gd-edit-item-icon class="icon-btn-15"></gd-edit-item-icon>
                                            <span>{{ displayEditText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayRemoveButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onRemoveButtonClick($event,row.key)" v-bind:class="{disabled:readonlyRow.indexOf(row.key)>=0}" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #C01537;min-width: 55px;color: #FFFFFF;">
                                            <gd-remove-item-icon class="icon-btn-15"></gd-remove-item-icon>
                                            <span>{{ displayRemoveText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayLinkButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onLinkButtonClick" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #003C8F;min-width: 65px;color: #FFFFFF;">
                                            <gd-external-link-icon class="icon-btn-15"></gd-external-link-icon>
                                            <span>{{ displayLinkText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li v-if="displayProcessButton">
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onProcessButtonClick" v-bind:class="{disabled:row.isProcessBtn}" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #003C8F;min-width: 65px;color: #FFFFFF;">
                                            <gd-external-link-icon class="icon-btn-15"></gd-external-link-icon>
                                            <span>{{ displayProcessText }}</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </td>
                    <td v-if="showSortColumn" class="editor-column" :style="editColumnStyle" @click.stop="onRowSelected($event,row.key)">
                        <ul class="editor-btns">
                            <li>
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onSortUpButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;width: 55px;color: #FFFFFF;">
                                            <gd-arrow-up-icon class="icon-btn-15"></gd-arrow-up-icon>
                                            <span>上へ</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <div class="">
                                        <button type="button" @click.stop="onSortDownButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;width: 55px;color: #FFFFFF;">
                                            <gd-arrow-down-icon class="icon-btn-15"></gd-arrow-down-icon>
                                            <span>下へ</span>
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </td>
                    <td v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;" @click.stop="onRowSelected($event,row.key)"></td>
                </tr>

                <tr v-if="!pages.length || (pages[activePage] ? !pages[activePage].length : false)">
                    <td :colspan="getColumnSpan()">{{ noFoundMessage }}</td>
                </tr>

            </tbl-body>
            <tbl-head v-if="tfoot && !enableSumFooter" tag="tfoot">
                <tr>
                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                        <div v-if="multiSelectable && showSelectCheckbox" class="form-check" style="padding-left: 0;display: flex;align-items: center;justify-content: center;">
<!--                            <input type="checkbox" class="form-check-input" :id="comp_uuid + '_select_all_foot'" name="row_select_all_foot" v-model="selectAll">-->
<!--                            <label class="form-check-label" :for="comp_uuid + '_select_all_foot'" :style="checkboxCellStyle"></label>-->
                        </div>
                        <div v-if="selectable && showSelectCheckbox"></div>
                    </th>
                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle">編集</th>
                    <th v-for="column in columns" :key="column.field+'_foot'" :class="column.footerClass" :style="column.footerStyle">
                        <div>{{ column.label }}</div>
                    </th>
                    <th v-if="showEditColumnState" class="" :style="editColumnStyle">編集</th>
                    <th v-if="showSortColumn" class="" :style="editColumnStyle">並び替え</th>
                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                </tr>
            </tbl-head>

            <tbl-head v-if="!tfoot && enableSumFooter" tag="tfoot">
                <tr>
                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                        <div v-if="multiSelectable && showSelectCheckbox" class="form-check" style="padding-left: 0;display: flex;align-items: center;justify-content: center;">
<!--                            <input type="checkbox" class="form-check-input" :id="comp_uuid + '_select_all_foot'" name="row_select_all_foot" v-model="selectAll">-->
<!--                            <label class="form-check-label" :for="comp_uuid + '_select_all_foot'" :style="checkboxCellStyle"></label>-->
                        </div>
                        <div v-if="selectable && showSelectCheckbox"></div>
                    </th>
                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle"></th>
                    <th v-for="(column, columnidx) in columns" :key="column.field+'_sum_foot'" :class="column.headerClass" :style="column.headerStyle" style="padding: 0.75rem">
                        <div v-if="columnidx===0" class="w-100 text-center">合計</div>
                        <div v-else-if="column.doSum" class="w-100 text-right">{{ calcSumValue(columnidx, column.doSumToCurrency) }}</div>
                        <div v-else-if="column.doSumOclock" class="w-100 text-right">{{ calcSumOclock(columnidx) }}</div>
                        <div v-else-if="column.doSumCount" class="w-100 text-right">{{ calcSumCount(columnidx) }}</div>
                        <div v-else></div>
                    </th>
                    <th v-if="showEditColumnState" class="" :style="editColumnStyle"></th>
                    <th v-if="showSortColumn" class="" :style="editColumnStyle"></th>
                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                </tr>
            </tbl-head>

            <tbl-head v-if="!tfoot && enableOriginalFooter" tag="tfoot">
                <tr>
                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                        <div v-if="multiSelectable && showSelectCheckbox" class="form-check" style="padding-left: 0;display: flex;align-items: center;justify-content: center;"></div>
                        <div v-if="selectable && showSelectCheckbox"></div>
                    </th>
                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle"></th>

                    <th v-for="columnFooter in columnFooters" :class="columnFooter.footerClass" :style="columnFooter.footerStyle" style="padding: 0.75rem">
                        <div v-html="columnFooter.label"></div>
                    </th>

                    <th v-if="showEditColumnState" class="" :style="editColumnStyle"></th>
                    <th v-if="showSortColumn" class="" :style="editColumnStyle"></th>
                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                </tr>
            </tbl-head>
        </tbl>
        <!-- Main table -->

        <!-- ScrollY table -->
        <div v-if="scrollY" class="dataTables_scroll">
            <div v-if="scrollY" class="dataTables_scrollHead" style="padding-right: 17px">
                <div class="dataTables_scrollHeadInner">
                    <scroll-sync horizontal group="scrolly">
                        <tbl v-bind="tableProps" sm datatable class="header-table-wrapper">
                            <tbl-head v-if="showHeaderState" :color="headerColor" :textWhite="headerWhite">
                                <tr v-if="showHeaderUpperState" class="header-upper">
                                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :class="checkboxClass" :style="checkboxColumnStyle"></th>
                                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle"></th>
                                    <th v-for="columnUpper in columnUppers" :class="columnUpper.headerClass" :style="columnUpper.headerStyle" :colspan="columnUpper.colSpan">
                                        <div v-html="columnUpper.label"></div>
                                    </th>
                                    <th v-if="showEditColumnState" class="" :style="editColumnStyle"></th>
                                    <th v-if="showSortColumn" class="" :style="editColumnStyle"></th>
                                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                                </tr>
                                <tr>
                                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                                        <div v-if="multiSelectable && showSelectCheckbox && showSelectAllState" class="form-check" style="width: 100%;height: 100%;padding-left: 0;display: flex;align-items: center;justify-content: center;">
                                            <input type="checkbox" class="form-check-input" :id="comp_uuid + '_select_all'" name="row_select_all" v-model="selectAll">
                                            <label class="form-check-label" :for="comp_uuid + '_select_all'" :style="checkboxCellStyle"></label>
                                        </div>
                                        <div v-if="selectable && showSelectCheckbox"></div>
                                    </th>
                                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle">編集</th>
                                    <th v-for="column in columns" :key="column.field" :class="column.headerClass" :style="column.headerStyle" v-on:click="sort(column.field, column.sort)">
                                        <div>{{ column.label }}</div>
                                    </th>
                                    <th v-if="showEditColumnState" class="" :style="editColumnStyle">編集</th>
                                    <th v-if="showSortColumn" class="" :style="editColumnStyle">並び替え</th>
                                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                                </tr>
                            </tbl-head>
                        </tbl>
                    </scroll-sync>
                </div>
            </div>
            <scroll-sync horizontal group="scrolly">
                <tbl v-bind="tableProps" sm datatable class="record-table-wrapper">
                    <tbl-body>
<!--                        <tr v-for="(row,index) in pages[activePage]" :key="row.key" :data-key="row.key" :data-index="index" @dblclick.stop="onRowDblClick($event,row.key)" @click.stop="onRowSelected($event,row.key)" :class="[{'row-selected': row.selected }]">-->
                        <tr v-for="(row,index) in pages[activePage]" :key="row.key" :data-key="row.key" :data-index="index" @dblclick.stop="onRowDblClick($event,row.key)" :class="[{'row-selected': row.selected }]">
                            <td v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                                <div class="form-check" style="padding-left: 0;display: flex;align-items: center;justify-content: center;">
                                    <input type="checkbox" class="form-check-input" :id="comp_uuid + '_row_checkbox_' + index" name="row_selected" :checked="rowSelection.indexOf(row.key)>=0" v-bind:value="row.key" v-on:change.stop="onCheckRow($event,row.key)" :disabled="readonlyRow.indexOf(row.key)>=0">
                                    <label class="form-check-label" :for="comp_uuid + '_row_checkbox_' + index" :style="checkboxCellStyle"></label>
                                </div>
                            </td>
                            <td v-if="showTopEditColumn" class="editor-column" :style="editColumnStyle" @click.stop="onRowSelected($event,row.key)">
                                <ul class="editor-btns">
                                    <li v-if="displayDownloadButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onDownloadButtonClick($event,row.key)" class="btn old-btn  btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 105px;color: #FFFFFF;">
                                                    <gd-download-item-icon class="icon-btn-15"></gd-download-item-icon>
                                                    <span>{{ displayDownloadText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayAddButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onAddButtonClick($event,row.key)" class="btn old-btn  btn-sm center-icon-btn role-add-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                                    <gd-add-item-icon class="icon-btn-15"></gd-add-item-icon>
                                                    <span>{{ displayAddText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayEditButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onEditButtonClick($event,row.key)" class="btn old-btn  btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                                    <gd-edit-item-icon class="icon-btn-15"></gd-edit-item-icon>
                                                    <span>{{ displayEditText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayRemoveButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onRemoveButtonClick($event,row.key)" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #C01537;min-width: 55px;color: #FFFFFF;">
                                                    <gd-remove-item-icon class="icon-btn-15"></gd-remove-item-icon>
                                                    <span>{{ displayRemoveText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayLinkButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onLinkButtonClick" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #003C8F;min-width: 65px;color: #FFFFFF;">
                                                    <gd-external-link-icon class="icon-btn-15"></gd-external-link-icon>
                                                    <span>{{ displayLinkText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayProcessButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onProcessButtonClick" v-bind:class="{disabled:row.isProcessBtn}" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #003C8F;min-width: 65px;color: #FFFFFF;">
                                                    <gd-external-link-icon class="icon-btn-15"></gd-external-link-icon>
                                                    <span>{{ displayProcessText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </td>
                            <td v-if="editable" v-for="(value, key) in row.data" :key="key" :class="row.class[key]" :style="row.style[key]" @click.stop="onRowSelected($event,row.key)">
<!--                                <input v-if="row.editorType[key] === 'string'" type="text" class="form-control" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]"/>-->
<!--                                <input v-else-if="row.editorType[key] === 'number'" type="number" class="form-control" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]"/>-->
                                <input v-if="row.editorType[key] === 'string'" type="text" :class="row.editorClass[key]" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]" :disabled="readonlyRow.indexOf(row.key)>=0"/>
                                <input v-else-if="row.editorType[key] === 'number'" type="number" :class="row.editorClass[key]" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]" :disabled="readonlyRow.indexOf(row.key)>=0"/>
                                <input v-else-if="row.editorType[key] === 'time'" type="time" :class="row.editorClass[key]" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]" :disabled="readonlyRow.indexOf(row.key)>=0"/>
                                <select v-else-if="row.editorType[key] === 'select'" v-model="row.data[key]" :class="row.editorClass[key]" :name="row.editorName[key]" @change="changeSelectedIndex($event)" :disabled="readonlyRow.indexOf(row.key)>=0">
                                    <option v-for="list in row.listData[key]" :value="list.key">{{list.value}}</option>
                                </select>
                                <md-datepicker v-else-if="row.editorType[key] === 'date'"  :class="row.editorClass[key]" :name="row.editorName[key]" :ref="row.editorName[key]" :value="value" @on-value-change="onValueChangeDatePicker($event, index)" :attr-disabled="readonlyRow.indexOf(row.key)>=0"/>
                                <textarea v-else-if="row.editorType[key] === 'textarea'" :class="row.editorClass[key]" :value="value" :name="row.editorName[key]" :readOnly="row.editorReadOnly[key]" :disabled="readonlyRow.indexOf(row.key)>=0"/>
                                <div v-else v-html="value"></div>
                            </td>
                            <td v-if="!editable" v-for="(value, key) in row.data" :key="key" :class="row.class[key]" :style="row.style[key]" @click.stop="onRowSelected($event,row.key)">
                                <div v-html="value"></div>
                            </td>
                            <td v-if="showEditColumnState" class="editor-column" :style="editColumnStyle" @click.stop="onRowSelected($event,row.key)">
                                <ul class="editor-btns">
                                    <li v-if="displayDownloadButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onDownloadButtonClick($event,row.key)" class="btn old-btn  btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 105px;color: #FFFFFF;">
                                                    <gd-download-item-icon class="icon-btn-15"></gd-download-item-icon>
                                                    <span>{{ displayDownloadText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayAddButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onAddButtonClick($event,row.key)" class="btn old-btn  btn-sm center-icon-btn role-add-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                                    <gd-add-item-icon class="icon-btn-15"></gd-add-item-icon>
                                                    <span>{{ displayAddText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayEditButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onEditButtonClick($event,row.key)" class="btn old-btn  btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                                    <gd-edit-item-icon class="icon-btn-15"></gd-edit-item-icon>
                                                    <span>{{ displayEditText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayRemoveButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onRemoveButtonClick($event,row.key)" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #C01537;min-width: 55px;color: #FFFFFF;">
                                                    <gd-remove-item-icon class="icon-btn-15"></gd-remove-item-icon>
                                                    <span>{{ displayRemoveText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayLinkButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onLinkButtonClick" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #003C8F;min-width: 65px;color: #FFFFFF;">
                                                    <gd-external-link-icon class="icon-btn-15"></gd-external-link-icon>
                                                    <span>{{ displayLinkText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="displayProcessButton">
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onProcessButtonClick" v-bind:class="{disabled:row.isProcessBtn}" class="btn old-btn  btn-sm center-icon-btn role-remove-btn" style="background-color: #003C8F;min-width: 65px;color: #FFFFFF;">
                                                    <gd-external-link-icon class="icon-btn-15"></gd-external-link-icon>
                                                    <span>{{ displayProcessText }}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </td>
                            <td v-if="showSortColumn" class="editor-column" :style="editColumnStyle" @click.stop="onRowSelected($event,row.key)">
                                <ul class="editor-btns">
                                    <li>
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onSortUpButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                                    <gd-arrow-up-icon class="icon-btn-15"></gd-arrow-up-icon>
                                                    <span>上へ</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <div class="">
                                                <button type="button" @click.stop="onSortDownButtonClick($event,row.key)" class="btn old-btn btn-sm center-icon-btn role-edit-btn" style="background-color: #003C8F;min-width: 55px;color: #FFFFFF;">
                                                    <gd-arrow-down-icon class="icon-btn-15"></gd-arrow-down-icon>
                                                    <span>下へ</span>
                                                </button>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </td>
                            <td v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;" @click.stop="onRowSelected($event,row.key)"></td>
                        </tr>

                        <tr v-if="!pages.length || (pages[activePage] ? !pages[activePage].length : false)">
                            <td :colspan="getColumnSpan()">{{ noFoundMessage }}</td>
                        </tr>

                    </tbl-body>
                </tbl>
            </scroll-sync>
            <div v-if="tfoot || enableSumFooter || enableOriginalFooter" class="dataTables_scrollFoot" style="padding-right: 17px">
                <div class="dataTables_scrollFootInner">
                    <scroll-sync horizontal group="scrolly">
                        <tbl v-bind="tableProps" sm datatable>
                            <tbl-head v-if="tfoot && !enableSumFooter && !enableOriginalFooter" tag="tfoot">
                                <tr>
                                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                                        <div v-if="multiSelectable && showSelectCheckbox" class="form-check" style="padding-left: 0;display: flex;align-items: center;justify-content: center;">
<!--                                            <input type="checkbox" class="form-check-input" :id="comp_uuid + '_select_all_foot'" name="row_select_all" v-model="selectAll">-->
<!--                                            <label class="form-check-label" :for="comp_uuid + '_select_all_foot'" :style="checkboxCellStyle"></label>-->
                                        </div>
                                        <div v-if="selectable && showSelectCheckbox"></div>
                                    </th>
                                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle">編集</th>
                                    <th v-for="column in columns" :key="column.field+'_foot'" :class="column.footerClass" :style="column.footerStyle">
                                        <div>{{ column.label }}</div>
                                    </th>
                                    <th v-if="showEditColumnState" class="" :style="editColumnStyle">編集</th>
                                    <th v-if="showSortColumn" class="" :style="editColumnStyle">並び替え</th>
                                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                                </tr>
                            </tbl-head>

                            <tbl-head v-if="!tfoot && enableSumFooter" tag="tfoot">
                                <tr>
                                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                                        <div v-if="multiSelectable && showSelectCheckbox" class="form-check" style="padding-left: 0;display: flex;align-items: center;justify-content: center;">
<!--                                            <input type="checkbox" class="form-check-input" :id="comp_uuid + '_select_all_foot'" name="row_select_all" v-model="selectAll">-->
<!--                                            <label class="form-check-label" :for="comp_uuid + '_select_all_foot'" :style="checkboxCellStyle"></label>-->
                                        </div>
                                        <div v-if="selectable && showSelectCheckbox"></div>
                                    </th>
                                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle"></th>
                                    <th v-for="(column, columnidx) in columns" :key="column.field+'_sum_foot'" :class="column.headerClass" :style="column.headerStyle" style="padding: 0.75rem">
                                        <div v-if="columnidx===0" class="w-100 text-center">合計</div>
                                        <div v-else-if="column.doSum" class="w-100 text-right">{{ calcSumValue(columnidx, column.doSumToCurrency) }}</div>
                                        <div v-else-if="column.doSumOclock" class="w-100 text-right">{{ calcSumOclock(columnidx) }}</div>
                                        <div v-else-if="column.doSumCount" class="w-100 text-right">{{ calcSumCount(columnidx) }}</div>
                                        <div v-else></div>
                                    </th>
                                    <th v-if="showEditColumnState" class="" :style="editColumnStyle"></th>
                                    <th v-if="showSortColumn" class="" :style="editColumnStyle"></th>
                                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                                </tr>
                            </tbl-head>

                            <tbl-head v-if="!tfoot && enableOriginalFooter" tag="tfoot">
                                <tr>
                                    <th v-if="(selectable || multiSelectable) && showSelectCheckbox" :style="checkboxColumnStyle" :class="checkboxClass">
                                        <div v-if="multiSelectable && showSelectCheckbox" class="form-check" style="padding-left: 0;display: flex;align-items: center;justify-content: center;"></div>
                                        <div v-if="selectable && showSelectCheckbox"></div>
                                    </th>
                                    <th v-if="showTopEditColumn" class="" :style="editColumnStyle"></th>

                                    <th v-for="columnFooter in columnFooters" :class="columnFooter.footerClass" :style="columnFooter.footerStyle" style="padding: 0.75rem">
                                        <div v-html="columnFooter.label"></div>
                                    </th>

                                    <th v-if="showEditColumnState" class="" :style="editColumnStyle"></th>
                                    <th v-if="showSortColumn" class="" :style="editColumnStyle"></th>
                                    <th v-if="showDummyColumn" class="dummy-column" style="min-width: 30px;"></th>
                                </tr>
                            </tbl-head>
                        </tbl>
                    </scroll-sync>
                </div>
            </div>
        </div>
        <!-- ScrollY table -->

        <!-- Labels and pagination -->
        <div v-if="pagination" class="row">
            <div class="col-sm-12 col-md-5">
                <div class="dataTables_info" role="status" aria-live="polite">
                    {{ showingText }}: {{ activePage > 0 ? (activePage * entries) + 1 : activePage + 1 }} - {{ pages.length - 1 > activePage ? pages[activePage].length * (activePage + 1) : filteredRows.length }} ({{ filteredRows.length }})
                </div>
            </div>
            <div class="col-sm-12 col-md-7">
                <div class="dataTables_paginate float-right">
                    <pagination id="pagination">
                        <page-item v-if="pages.length > display" v-on:click.native="changePage(0)" :disabled="activePage === 0 ? true : false">
                            <mdb-icon v-if="arrows" icon="angle-double-left"/>
                            <p v-else class="pagination">{{ start }}</p>
                        </page-item>
                        <page-item v-on:click.native="changePage(activePage-1)" :disabled="activePage === 0 ? true : false">
                            <mdb-icon v-if="arrows" icon="angle-left"/>
                            <p v-else class="pagination">{{ previous }}</p>
                        </page-item>
                        <page-item v-for="(page, index) in visiblePages" :key="index" v-on:click.native="changePage(pages.indexOf(visiblePages[index]))" :active="activePage === pages.indexOf(visiblePages[index]) ? true : false">
                            {{ pages.indexOf(visiblePages[index]) + 1 }}
                        </page-item>
                        <page-item v-on:click.native="changePage(activePage+1)" :disabled="activePage === pages.length-1 ? true : false">
                            <mdb-icon v-if="arrows" icon="angle-right"/>
                            <p v-else class="pagination">{{ next }}</p>
                        </page-item>
                        <page-item v-if="pages.length > display" v-on:click.native="changePage(pages.length-1)" :disabled="activePage === pages.length-1 ? true : false">
                            <mdb-icon v-if="arrows" icon="angle-double-right"/>
                            <p v-else class="pagination">{{ end }}</p>
                        </page-item>
                    </pagination>
                </div>
            </div>
        </div>
        <!-- Labels and pagination -->

    </div>
</template>

<script>
    import Tbl from './Table';
    import TblHead from './TableHead';
    import TblBody from './TableBody';
    import Pagination from '../Components/Pagination';
    import PageItem from '../Components/PageItem';
    import mdbInput from '../Forms/Input';
    import DatatableSelect from './DatatableSelect';
    import DatatableSearch from './DatatableSearch';
    import mdbIcon from '../Content/Fa';
    import mdbRow from '../Layout/Row';
    import mdbCol from '../Layout/Col';
    import mdbBtn from '../Components/Button';
    import ScrollSync from '../../ScrollSync';
    import GdAddItemIcon from "../../CustomVueMaterial/custom/Common/icons/GdAddItemIcon";
    import GdEditItemIcon from "../../CustomVueMaterial/custom/Common/icons/GdEditItemIcon";
    import GdRemoveItemIcon from "../../CustomVueMaterial/custom/Common/icons/GdRemoveItemIcon";
    import GdExternalLinkIcon from "../../CustomVueMaterial/custom/Common/icons/GdExternalLinkIcon";
    import GdDownloadItemIcon from "../../CustomVueMaterial/custom/Common/icons/GdDownloadItemIcon";
    import GdArrowUpIcon from "../../CustomVueMaterial/custom/Common/icons/GDArrowUpIcon";
    import GdArrowDownIcon from "../../CustomVueMaterial/custom/Common/icons/GDArrowDownIcon";
    import mdDatepicker from '../../CustomVueMaterial/components/MdDatepicker/MdDatepicker.vue';

    const Datatable = {
        name: 'Datatable',
        props: {
            data: {
                type: [Object, String],
                default: () => ({
                    columns: [],
                    columnUppers: [],
                    columnFooters: [],
                    rows: [],
                    rowSelection: [],
                    readonlyRow: [],
                })
            },
            editable: {
                type: Boolean,
                default: false
            },
            selectable: {
                type: Boolean,
                default: false
            },
            selectableMomentary: {
                type: Boolean,
                default: false
            },
            multiSelectable: {
                type: Boolean,
                default: false
            },
            showSelectCheckbox: {
                type: Boolean,
                default: false
            },
            autoWidth: {
                type: Boolean,
                default: false
            },
            bordered: {
                type: Boolean,
                default: false
            },
            borderless: {
                type: Boolean,
                default: false
            },
            dark: {
                type: Boolean,
                default: false
            },
            fixed: {
                type: Boolean,
                default: false
            },
            headerColor: {
                type: String
            },
            headerWhite: {
                type: Boolean,
                default: false
            },
            hover: {
                type: Boolean,
                default: false
            },
            maxWidth: {
                type: String
            },
            maxHeight: {
                type: String
            },
            order: {
                type: Array
            },
            pagination: {
                type: Boolean,
                default: true
            },
            responsive: {
                type: Boolean,
                default: false
            },
            responsiveSm: {
                type: Boolean,
                default: false
            },
            responsiveMd: {
                type: Boolean,
                default: false
            },
            responsiveLg: {
                type: Boolean,
                default: false
            },
            responsiveXl: {
                type: Boolean,
                default: false
            },
            scrollY: {
                type: Boolean,
                default: false
            },
            searching: {
                type: Boolean,
                default: true
            },
            sorting: {
                type: Boolean,
                default: true
            },
            striped: {
                type: Boolean,
                default: false
            },
            start: {
                type: String,
                default: '先頭'
            },
            end: {
                type: String,
                default: '最終'
            },
            next: {
                type: String,
                default: '次'
            },
            previous: {
                type: String,
                default: '前'
            },
            arrows: {
                type: Boolean,
                default: false
            },
            defaultEntries:{
               type: Number,
               default: 20,
            } ,
            display: {
                type: Number,
                default: 5
            },
            defaultRow: {
                type: String,
                default: '-'
            },
            defaultCol: {
                type: String,
                default: 'undefined'
            },
            tfoot: {
                type: Boolean,
                default: true
            },
            reactive: {
                type: Boolean,
                default: false
            },
            refresh: {
                type: Boolean,
                default: false
            },
            time: {
                type: Number,
                default: 5000
            },
            searchPlaceholder: {
                type: String
            },
            entriesTitle: {
                type: String
            },
            noFoundMessage: {
                type: String,
                default: '一致するレコードがありません'
            },
            showingText: {
                type: String,
                default: "表示"
            },
            showEditColumn: {
                type: Boolean,
                default: false
            },
            showTopEditColumn: {
                type: Boolean,
                default: false
            },
            keyColumn: {
                type: String,
                default: "id"
            },
            editColumnStyle: {
                type: Array,
                default: () => [{'width': '150px', 'min-width': '150px'}]
            },
            checkboxColumnStyle: {
                type: Array,
                default: () => [{'width': '60px', 'min-width': '60px'}]
            },
            checkboxCellStyle: {
                type: Array,
                default: () => [{'padding-left': '18px'}]
            },
            checkboxClass: {
                type: Array,
                default: () => []
            },
            displayDownloadButton: {
                type: Boolean,
                default: false
            },
            displayDownloadText:{
                type: String,
                default: "ダウンロード"
            },
            displayAddButton: {
                type: Boolean,
                default: false
            },
            displayAddText:{
                type: String,
                default: "追加"
            },
            displayEditButton: {
                type: Boolean,
                default: true
            },
            displayEditText:{
                type: String,
                default: "編集"
            },
            displayRemoveButton: {
                type: Boolean,
                default: true
            },
            displayRemoveText:{
                type: String,
                default: "削除"
            },
            displayLinkButton: {
                type: Boolean,
                default: false
            },
            displayLinkText:{
                type: String,
                default: "リンク"
            },
            displayProcessButton: {
                type: Boolean,
                default: false
            },
            displayProcessText:{
                type: String,
                default: "処理"
            },
            showSortColumn: {
                type: Boolean,
                default: false
            },
            showDummyColumn: {
                type: Boolean,
                default: false
            },
            enableSumFooter: {
                type: Boolean,
                default: false
            },
            enableOriginalFooter: {
                type: Boolean,
                default: false
            },
            sticky: {
                type: Boolean,
                default: false
            },
            enableColumnResize: {
                type: Boolean,
                default: false
            },
            showSelectAll: {
                type: Boolean,
                default: true
            },
            isCheck: {
                type: Boolean,
                default: true
            },
            showHeader: {
                type: Boolean,
                default: true
            },
            showHeaderUpper: {
                type: Boolean,
                default: false
            },

        },
        data() {
            return {
                updatedKey: null,
                reactiveFlag: false,
                recentSort: null,
                interval: null,
                rows: this.data.rows || [],
                columns: this.data.columns || [],
                columnUppers: this.data.columnUppers || [],
                columnFooters: this.data.columnFooters || [],
                options: [10, 20, 40, 60, 80, 100],
                entries: this.defaultEntries,
                pages: [],
                activePage: 0,
                search: '',
                tableProps: {
                    autoWidth: this.autoWidth,
                    bordered: this.bordered,
                    borderless: this.borderless,
                    dark: this.dark,
                    fixed: this.fixed,
                    hover: this.hover,
                    responsive: this.responsive,
                    responsiveSm: this.responsiveSm,
                    responsiveMd: this.responsiveMd,
                    responsiveLg: this.responsiveLg,
                    responsiveXl: this.responsiveXl,
                    striped: this.striped,
                    dtScrollY: this.scrollY,
                    maxHeight: this.maxHeight,
                    sticky: this.sticky && !this.scrollY,
                },
                wrapperStyle: {
                    maxWidth: this.maxWidth ? this.maxWidth : '100%',
                    margin: '0 auto'
                },
                defaultOrder: [],
                rowSelection: this.data.rowSelection || [],
                readonlyRow: this.data.readonlyRow || [],
                comp_uuid: '',
                sortCancel: false,
                showSelectAllState: this.showSelectAll || false,
                showEditColumnState: this.showEditColumn || false,
                showHeaderState: this.showHeader || true,
                showHeaderUpperState: this.showHeaderUpper || false,
            };
        },
        components: {
            GdArrowDownIcon,
            GdArrowUpIcon,
            GdExternalLinkIcon,
            GdRemoveItemIcon,
            GdAddItemIcon,
            GdEditItemIcon,
            GdDownloadItemIcon,
            ScrollSync,
            DatatableSearch,
            DatatableSelect,
            Tbl,
            TblHead,
            TblBody,
            Pagination,
            PageItem,
            mdbInput,
            mdbIcon,
            mdbRow,
            mdbCol,
            mdbBtn,
            mdDatepicker,
        },
        computed: {
            rowsDisplay() {
                return this.formatRows();
            },
            // filter objects by parameters match
            filteredRows() {
                return this.rowsDisplay.filter(row => {
                    return row.data.filter(value => value
                        .toString()
                        .toLowerCase()
                        .match(this.search.toLowerCase()))
                        .length > 0;
                });
            },
            visiblePages() {
                let start = this.activePage - Math.floor(this.display / 2) > 0 ? this.activePage - Math.floor(this.display / 2) : 0;
                let end = start + this.display < this.pages.length ? start + this.display : this.pages.length;
                if (end - start < this.display && end - this.display >= 0) {
                    start = end - this.display;
                }
                return this.pages.slice(start, end);
            },
            componentKey() {
                return this.updatedKey;
            },
            calcSumValue() {
                self = this;
                return function (idx, toCurrency) {
                    let ret = 0;
                    // let reg = new RegExp();
                    for (let i = 0; i < self.filteredRows.length; i++) {
                        let wk = String(self.filteredRows[i]['data'][idx]).replace(/,/g, '');
                        let arr = wk.split(/[^0-9.-]/);
                        for (const elem of arr) {
                            let wk = elem.replace(/[^0-9.-]/g, '');
                            if (!isNaN(Number(wk))) {
                                ret = ret + Number(wk);
                            }
                        }
                    }
                    if (toCurrency !== null && !isNaN(Number(toCurrency))){
                        const scale = Number(toCurrency);
                        const re = /(\d)(?=(\d\d\d)+(?!\d))/g;
                        return Number(String(ret).replace(/,/g, '')).toFixed(scale).replace(re, '$1,');
                    }
                    return ret;
                }
            },
            calcSumOclock() {
                self = this;
                return function(idx) {
                    let ret = '';
                    let hour = 0;
                    let minute = 0;
                    for (let i = 0; i < self.filteredRows.length; i++ ){
                        let wk = String(self.filteredRows[i]['data'][idx]);
                        let cellArr = wk.split(/[^0-9:-]/);
                        for (const elem of cellArr) {
                            if (String(elem) === '-') { continue; }
                            let arr = elem.split(':');
                            if (arr.length === 2 && !isNaN(Number(arr[0])) && !isNaN(Number(arr[1])) ){
                                minute = minute + (Number(arr[0]) * 60) + Number(arr[1]);
                            }
                        }
                    }
                    hour = Math.floor(minute / 60);
                    minute = minute - (hour * 60);
                    ret = String(hour) + ':' + ('00' + String(minute)).slice(-2);
                    return ret;
                }
            },
            calcSumCount() {
                self = this;
                return function(idx) {
                    let ret = 0;
                    for (let i = 0; i < self.filteredRows.length; i++) {
                        let wk = String(self.filteredRows[i]['data'][idx]);
                        if (String(wk) === '-') { continue; }
                        ret +=1;
                    }
                    return ret;
                }
            },
            selectAll: {
                get: function () {
                    if (this.filteredRows.length !== 0 && this.rowSelection.length === this.filteredRows.length) {
                        return true
                    } else {
                        return false
                    }
                },
                set: function (value) { //全選択のチェックボックスを操作した場合
                    //空の配列を用意
                    let checkArray = [];
                    let existsArray = [];

                    //チェックが入った場合（trueでの判定）
                    if (value) {
                        const _this = this;
                        this.filteredRows.forEach(function (row) {
                            if (_this.readonlyRow.includes(row.key) && _this.rowSelection.includes(row.key)) {
                                existsArray.push(row.key);
                            } else {
                                checkArray.push(row.key);
                            }
                        });
                    } else {
                        const _this = this;
                        this.filteredRows.forEach(function (row) {
                            if (_this.readonlyRow.includes(row.key) && _this.rowSelection.includes(row.key)) {
                                existsArray.push(row.key);
                            }
                        });
                    }
                    if (existsArray.length > 0) {
                        checkArray = checkArray.concat(existsArray);
                    }
                    this.rowSelection = checkArray;
                    const e = new Event('selectAllEvent');
                    this.onRowSelected(e, this.rowSelection);
                    this.onCheckRow(e, this.rowSelection);
                }
            },
        },
        methods: {
            changePage(index) {
                this.activePage = index;
            },
            sort(field, sort, forced = false) {
                if ((!sort || this.sortCancel) && !forced) {
                    this.sortCancel = false;
                    return false;
                }

                this.recentSort = {field, sort};
                if (this.sorting || forced) {

                    sort === 'asc' ?
                        // this.rows.sort((a, b) => (a[field] > b[field] ? 1 : -1)) :
                        // this.rows.sort((a, b) => (a[field] > b[field] ? -1 : 1));
                        //this.rows.sort((a, b) => ( ( a[field] ? a[field] : '' ) > ( b[field] ? b[field] : '' ) ? 1 : -1)) :
                        //this.rows.sort((a, b) => ( ( a[field] ? a[field] : '' ) > ( b[field] ? b[field] : '' ) ? -1 : 1));
                        this.rows.sort((a, b) => (this.sortcompare(a[field],b[field],false)) ):
                        this.rows.sort((a, b) => (this.sortcompare(a[field],b[field])) );
                    if (sort === 'none') {
                        this.rows.sort((a, b) => {
                            const akey = a[this.keyColumn];
                            const bKey = b[this.keyColumn];
                            const aIdx = this.defaultOrder.findIndex((v) => String(v) === String(akey));
                            const bIdx = this.defaultOrder.findIndex((v) => String(v) === String(bKey));
                            if (bIdx < aIdx) return 1;
                            if (bIdx > aIdx) return -1;
                            return 0;
                        });
                    }
                    this.columns[this.columns.findIndex(column => column.field === field)].sort = sort === 'asc' ? 'desc' : sort === 'desc' ? 'none' : 'asc';
                    this.columns.forEach((col, i) => {
                        if (col) {
                            let oldArray = this.columns[i].headerClass;
                            if (!oldArray) {
                                oldArray = [];
                            }
                            const newArray = oldArray.filter(n => (n !== 'sorting_asc' && n !== 'sorting_desc' && n !== 'sorting_none'));
                            this.columns[i].headerClass = newArray;
                        }
                    });
                    this.columns[this.columns.findIndex(column => column.field === field)].headerClass.push('sorting' + (sort === 'asc' ? '_asc' : sort === 'desc' ? '_desc' : '_none'));
                }
            },
            sortcompare(valuea,valueb,desc = true){
                if ( valuea !== valuea && valueb !== valueb ) return 0;
                if (valuea !== valuea) return 1;
                if (valueb !== valueb) return -1;

                if (valuea == null && valueb == null) return 0;
                if (valuea == null) return 1;
                if (valueb == null) return -1;

                if (valuea === '' && valueb === '') return 0;
                if (valuea === '') return 1;
                if (valueb === '') return -1;

                let sig = desc ? 1 : -1;

                let rtn = valuea < valueb ? sig : (valuea > valueb ? -sig : 0);

                return rtn;
            },
            updateEntries(value) {
                this.entries = Number(value) ? Number(value) : this.entries;
            },
            updateSearch(value) {
                this.search = this.escapeRegExp(value);
                this.activePage = 0;
            },
            filterArray() {
                if (this.filter) {
                    this.rows.map(row => {
                        if (this.filteredArray.indexOf(row[this.filter]) === -1) {
                            this.filteredArray.push(row[this.filter]);
                        }
                    });
                    this.filteredArray.sort();
                    this.filteredArray = this.filteredArray.filter((elem, index, self) => {
                        return index == self.indexOf(elem);
                    });

                    const existingOptions = this.filterOptions.map(option => option.value);
                    this.filteredArray.forEach(option => {
                        if (existingOptions.indexOf(option) === -1) {
                            this.filterOptions.push({value: option, text: option});
                        }
                    });
                }
            },
            escapeRegExp(string) {
                return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            },
            setDefaultColumns() {
                this.columns.forEach((col, i) => {
                    if (!col) {
                        this.columns[i] = {
                            label: this.defaultCol,
                            field: this.defaultCol.concat(i),
                            sort: this.sorting ? 'asc' : '',
                            headerClass: ['th-sm'],
                            fieldClass: [],
                            footerClass: ['th-sm'],
                            headerStyle: [],
                            fieldStyle: [],
                            footerStyle: [],
                            editorType: '',
                            editorName: '',
                            editorClass: [],
                            editorReadOnly: false,
                            doSum: false,
                            doSumOclock: false,
                            doSumCount: false,
                            doSumToCurrency: null,
                            listData: [],
                            canEditHeader: false,
                            headerEditorClass: '',
                            headerEditorName: '',
                        };
                    }
                    if (!col.headerClass) {
                        this.columns[i].headerClass = ['th-sm'];
                    }
                    if (col.sort) {
                        let oldArray = col.headerClass;
                        if (!oldArray) {
                            oldArray = [];
                        }
                        const index = oldArray.findIndex((v) => v === 'sorting');
                        if (index === -1) {
                            oldArray.push('sorting');
                            this.columns[i].headerClass = oldArray;
                        }
                    }
                });

            },
            formatRows() {
                this.setDefaultColumns();
                let arrRows = [];
                let headers = this.columns.map(col => col.field);
                this.rows.map(row => {
                    let newRow = [];
                    let fieldClass = [];
                    let fieldStyle = [];
                    let editorType = [];
                    let editorName = [];
                    let editorClass = [];
                    let editorReadOnly = [];
                    let listData = [];
                    let canEditHeader = [];
                    let headerEditorClass = [];
                    let headerEditorName = [];
                    headers.forEach(header => {
                        // let content = row[header] || this.defaultRow;
                        const targetColumn = this.columns[this.columns.findIndex(col => col.field === header)];
                        let content = "";
                        if (targetColumn && targetColumn.editorType) {
                            content = this.formatChange(row, header) == null ? '' : this.formatChange(row, header);
                        } else {
                            content = this.formatChange(row, header) || this.defaultRow;
                        }
                        newRow.push(content);
                        if (targetColumn && targetColumn.fieldClass) {
                            fieldClass.push(targetColumn.fieldClass);
                        } else {
                            fieldClass.push([]);
                        }
                        if (targetColumn && targetColumn.fieldStyle) {
                            fieldStyle.push(targetColumn.fieldStyle);
                        } else {
                            fieldStyle.push([]);
                        }
                        if (targetColumn && targetColumn.editorType) {
                            editorType.push(targetColumn.editorType);
                        } else {
                            editorType.push('');
                        }
                        if (targetColumn && targetColumn.editorName) {
                            editorName.push(targetColumn.editorName);
                        } else {
                            editorName.push('');
                        }
                        if (targetColumn && targetColumn.editorClass) {
                            editorClass.push(targetColumn.editorClass);
                        } else {
                            editorClass.push(['form-control']);
                        }
                        if (targetColumn && targetColumn.editorReadOnly) {
                            editorReadOnly.push(targetColumn.editorReadOnly);
                        } else {
                            editorReadOnly.push(false);
                        }
                        if (targetColumn && targetColumn.listData) {
                            listData.push(targetColumn.listData);
                        } else {
                            listData.push([]);
                        }
                        if (targetColumn && targetColumn.canEditHeader) {
                            canEditHeader.push(targetColumn.canEditHeader);
                        } else {
                            canEditHeader.push([]);
                        }
                        if (targetColumn && targetColumn.headerEditorClass) {
                            headerEditorClass.push(targetColumn.headerEditorClass);
                        } else {
                            headerEditorClass.push([]);
                        }
                        if (targetColumn && targetColumn.headerEditorName) {
                            headerEditorName.push(targetColumn.headerEditorName);
                        } else {
                            headerEditorName.push([]);
                        }
                    });
                    let obj = {};
                    obj.data = newRow;
                    obj.class = fieldClass;
                    obj.style = fieldStyle;
                    obj.editorType = editorType;
                    obj.editorName = editorName;
                    obj.editorClass = editorClass;
                    obj.editorReadOnly = editorReadOnly;
                    obj.key = row[this.keyColumn];
                    obj.isProcessBtn = row['is_disable_process_btn'];
                    if (this.rowSelection.includes(obj.key)) {
                        obj.selected = true;
                    } else {
                        obj.selected = false;
                    }
                    if (this.readonlyRow.includes(obj.key)) {
                        obj.readonlyRow = true;
                    } else {
                        obj.readonlyRow = false;
                    }
                    obj.listData = listData;
                    obj.canEditHeader = canEditHeader;
                    obj.headerEditorClass = headerEditorClass
                    obj.headerEditorName = headerEditorName;
                    arrRows.push(obj);
                });
                return arrRows;
            },
            fetchData() {
                fetch(this.data)
                    .then(res => res.json())
                    .then(json => {
                        this.columns = json.columns;
                        this.rows = json.rows;
                        this.$emit('fields', this.columns);
                    })
                    .then(data => {
                        if (this.recentSort) {
                            this.sort(this.recentSort.field, this.recentSort.sort);
                        }
                    })
                    .catch(err => console.log(err));
            },
            updateData(event) {
                if (this.$parent.onRefresh) {
                    this.$parent.onRefresh(event)
                } else {
                    this.fetchData();
                    this.reactiveFlag = true;
                    this.updatedKey = Math.floor(Math.random() * 100000000);
                }
            },
            onEditButtonClick(event, key) {
                const selectedKey = key;
                if (this.readonlyRow.includes(key)) return;
                if(this.isCheck) {
                    if (this.selectable) {
                        this.filteredRows.forEach((row, i) => {
                            if (row.readonlyRow) return;
                            if (row.key === key) {
                                row.selected = true;
                                const index = this.rowSelection.indexOf(row.key);
                                if (index !== -1) {
                                    this.rowSelection.splice(index, 1, key);
                                } else {
                                    this.rowSelection.push(key);
                                }
                            } else {
                                row.selected = false;
                                const index = this.rowSelection.indexOf(row.key);
                                if (index !== -1) {
                                    this.rowSelection.splice(index, 1);
                                }
                            }
                        })
                    } else if (this.multiSelectable) {
                        this.filteredRows.forEach((row, i) => {
                            if (row.readonlyRow) return;
                            if (row.key === key) {
                                row.selected = true;
                                const index = this.rowSelection.indexOf(row.key);
                                if (index !== -1) {
                                    this.rowSelection.splice(index, 1, key);
                                } else {
                                    this.rowSelection.push(key);
                                }
                            } else if (row.key === key && row.selected) {
                                row.selected = false;
                                const index = this.rowSelection.indexOf(row.key);
                                if (index !== -1) {
                                    this.rowSelection.splice(index, 1);
                                }
                            }
                        })
                    }
                }
                this.$emit('on-edit-button-click', event);
            },
            onAddButtonClick(event) {
                this.$emit('on-add-button-click', event);
            },
            onRemoveButtonClick(event, key) {
                if (this.readonlyRow.includes(key)) return;
                this.$emit('on-remove-button-click', event);
            },
            onLinkButtonClick(event) {
                this.$emit('on-link-button-click', event);
            },
            onProcessButtonClick(event) {
                this.$emit('on-process-button-click', event);
            },
            onSortUpButtonClick(event, key) {
                this.$emit('on-sort-up-button-click', {'event': event, 'key': key});
            },
            onSortDownButtonClick(event, key) {
                this.$emit('on-sort-down-button-click', {'event': event, 'key': key});
            },
            onDownloadButtonClick(event) {
                this.$emit('on-download-button-click', event);
            },
            onRowSelected(event, key) {
                const selectedKey = key;
                if (this.readonlyRow.includes(key)) return;
                if (this.selectable) {
                    this.filteredRows.forEach((row, i) => {
                        if (row.readonlyRow) return;
                        if (row.key === key && (!this.selectableMomentary && !row.selected)) {
                            row.selected = true;
                            const index = this.rowSelection.indexOf(row.key);
                            if (index !== -1) {
                                this.rowSelection.splice(index, 1, key);
                            } else {
                                this.rowSelection.push(key);
                            }
                        } else if (row.key === key && this.selectableMomentary) {
                            row.selected = true;
                            this.rowSelection.splice(0, this.rowSelection.length);
                            this.rowSelection.push(key);
                        } else {
                            row.selected = false;
                            const index = this.rowSelection.indexOf(row.key);
                            if (index !== -1) {
                                this.rowSelection.splice(index, 1);
                            }
                        }
                    })
                } else if (this.multiSelectable) {
                    this.filteredRows.forEach((row, i) => {
                        if (row.readonlyRow) return;
                        if (row.key === key && !row.selected) {
                            row.selected = true;
                            const index = this.rowSelection.indexOf(row.key);
                            if (index !== -1) {
                                this.rowSelection.splice(index, 1, key);
                            } else {
                                this.rowSelection.push(key);
                            }
                        } else if (row.key === key && row.selected) {
                            row.selected = false;
                            const index = this.rowSelection.indexOf(row.key);
                            if (index !== -1) {
                                this.rowSelection.splice(index, 1);
                            }
                        }
                    })
                }
                this.$emit('on-row-selected', event);
                this.reactiveFlag = true;
            },
            onRowDblClick(event, key) {
                this.$emit('on-row-dbl-click', event);
                this.reactiveFlag = true;
            },
            formatChange(row, header) {
                let ret = null;
                if (this.$parent.formatChange) {
                    ret = this.$parent.formatChange(row, header)
                } else {
                    ret = row[header];
                }
                return ret;
            },
            onCheckRow(event, key) {
                if (event.currentTarget) {
                    event.currentTarget.checked = true;
                }
                this.onRowSelected(event, key);
                this.$emit('on-check-row', event);
            },
            scrollSync(event) {
                console.log('scroll move');
            },
            log(msg, obj) {
                console.log(msg, obj);
            },
            getUuid() {
                return this.$uuid.v4();
            },
            getColumnSpan() {
                let span = 1;
                if (this.columns.length > 0) {
                    span = this.columns.length;
                }
                if (this.showTopEditColumn) {
                    span = span + 1
                }
                if (this.showSelectCheckbox) {
                    span = span + 1
                }
                // if (this.showEditColumn) {
                if (this.showEditColumnState) {
                    span = span + 1
                }
                if (this.showSortColumn) {
                    span = span + 1
                }
                if (this.showDummyColumn) {
                    span = span + 1
                }
                return span;
            },
            changeSelectedIndex(event) {
                // this.$emit('change-selected-index', {'event': event, 'key': key});
                this.$emit('change-selected-index', event);
            },
            changeHeader(event) {
                this.$emit('change-header', event);
            },
            onValueChangeDatePicker(value, index) {
                this.$emit('on-value-change-datepicker', {'value': value, 'index': index});
            },
        },
        created() {
            this.comp_uuid = this.getUuid();
        },
        mounted() {
            // bind data or download form API
            if (typeof this.data === 'string') {
                this.fetchData();
            }
            //reactivness in data table
            if (this.reactive) {
                this.interval = setInterval(this.updateData, this.time);
            }
            // findout rows amount, and slice it into array (split into pages)
            const pagesAmount = Math.ceil(this.filteredRows.length / this.entries);
            this.pages = [];
            if (this.pagination) {
                for (let i = 1; i <= pagesAmount; i++) {
                    const pageEndIndex = i * this.entries;
                    this.pages.push(this.filteredRows.slice(pageEndIndex - this.entries, pageEndIndex));
                }
            } else {
                this.pages.push(this.filteredRows);
            }
            this.activePage = 0;

            // initial sorting
            if (this.order) {
                this.sort(this.columns[this.order[0]].field, this.order[1], true);
            }

            if (this.enableColumnResize && this.showDummyColumn) {
                let thElm;
                let startOffset;
                let _this = this;
                Array.prototype.forEach.call(
                    document.querySelectorAll("table thead th"),
                    function (th) {
                        var grip = document.createElement('div');
                        grip.innerHTML = "&nbsp;";
                        grip.style.top = 0;
                        grip.style.right = 0;
                        grip.style.bottom = 0;
                        grip.style.width = '5px';
                        grip.style.position = 'absolute';
                        grip.style.cursor = 'col-resize';
                        grip.addEventListener('mousedown', function (e) {
                            thElm = th;
                            startOffset = th.offsetWidth - e.pageX;
                            _this.sortCancel = true;
                        });
                        th.appendChild(grip);
                    });

                document.addEventListener('mousemove', function (e) {
                    if (thElm) {
                        thElm.style.width = startOffset + e.pageX + 'px';
                    }
                });

                document.addEventListener('mouseup', function (e) {
                    thElm = undefined;
                });
            }

            this.$emit('pages', this.pages);
            this.$emit('fields', this.columns);
        },
        watch: {
            data(newVal) {
                this.columns = newVal.columns;
            },
            rows() {
                if (this.rows.length > 0 && this.defaultOrder.length !== this.rows.length) {
                    this.defaultOrder = [];
                    this.rows.map((row, i) => {
                        this.defaultOrder.push(row[this.keyColumn]);
                    });
                }
                this.filterArray();
            },
            entries() {
                // do the split every entry change (changing entries amount)
                const pagesAmount = Math.ceil(this.filteredRows.length / this.entries);
                this.pages = [];
                for (let i = 1; i <= pagesAmount; i++) {
                    const pageEndIndex = i * this.entries;
                    this.pages.push(this.filteredRows.slice(pageEndIndex - this.entries, pageEndIndex));
                }
                this.activePage = this.activePage < this.pages.length ? this.activePage : this.pages.length - 1;

                this.$emit('pages', this.pages);
            },
            filteredRows() {
                // do the split on every change in rows (searching)
                const pagesAmount = Math.ceil(this.filteredRows.length / this.entries);
                this.pages = [];
                if (this.pagination) {
                    for (let i = 1; i <= pagesAmount; i++) {
                        const pageEndIndex = i * this.entries;
                        this.pages.push(this.filteredRows.slice(pageEndIndex - this.entries, pageEndIndex));
                    }
                } else {
                    this.pages.push(this.filteredRows);
                }
                if (this.reactiveFlag === false) {
                    this.activePage = 0;
                }

                this.$emit('pages', this.pages);
            }
        },
        updated: function () {
            this.$nextTick(function () {
                this.$emit('updated');
            })
        }
    };

    export default Datatable;
    export {Datatable as mdbDatatable};
</script>

<style scoped>
    table.table-sticky thead th {
        /* 縦スクロール時に固定する */
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        /* tbody内のセルより手前に表示する */
        z-index: 1;
    }

    table.table-sticky thead th::before {
        content: "";
        border-top: 1px solid #C6C6C6;
        border-left: 1px solid #C6C6C6;
        border-bottom: 2px solid #C6C6C6;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        left: 0;
    }

    table.table-sticky thead th div input {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto;
    }

    table.table-sticky thead th:last-child::before {
        content: "";
        border-top: 1px solid #C6C6C6;
        border-left: 1px solid #C6C6C6;
        border-right: 1px solid #C6C6C6;
        border-bottom: 2px solid #C6C6C6;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        left: 0;
    }

    table.table-sticky.table-bordered thead th {
        border: none;
    }

    table.table-sticky.table-bordered thead th:last-child {
        border-right: 1px solid #C6C6C6;
    }

    table.table-sticky.table thead th {
        border: none;
    }
</style>

<style lang="scss">
    .pagination {
        margin-bottom: 0;
    }

    //table {
    //    border-collapse:separate;
    //    border-spacing:0;
    //}

    table.dataTable tbody {
        input[type="number"] {
            text-align: right;
        }

        tr.row-selected {
            background-color: #E7EEFF !important;
        }

        .md-icon {
            min-width: 15px;
        }
    }

    .dataTables_scroll .header-table-wrapper table.dataTable {
        margin-bottom: 0;
    }

    .md-icon {
        min-width: 15px;
    }

    table.table-sticky {
        border: none !important;
    }

    tr.header-upper th {
        border-bottom: 1px solid #c6c6c6;
    }
</style>
